import { IOption } from "@/types"
import { cn } from "@/utils"
import { ClassNamesConfig, GroupBase } from "react-select"

export const AutocompleteConfig = <T extends string | number, M extends object = object>(
  size: "sm" | "md",
  error: boolean,
): ClassNamesConfig<IOption<T, M>, false, GroupBase<IOption<T, M>>> => ({
  clearIndicator: () => {
    return cn(size === "sm" ? "!pr-2 !py-0" : "")
  },
  dropdownIndicator: () => cn("text-[#98A2B3] stroke-[1px]", size === "sm" ? "!pr-2 !py-0" : ""),
  placeholder: () => "!font-normal",
  indicatorSeparator: () => "hidden",
  menuList: () => "px-1 !rounded-[0] !border-red-500",
  menu: () => "!rounded-[0]",
  option: () => cn("!bg-[white] !text-[14px] text-black !font-weight-[400]", size === "sm" ? "!text-xs" : ""),
  menuPortal: () => "!z-[999999]",
  valueContainer: () => "!pl-4",
  control: () =>
    cn(
      "!rounded-[0] !outline-none !shadow-none !min-h-[auto] !border !border-[#c3ced7]",
      size === "sm" ? "h-[34px]" : "h-[40px]",
      error && "!border-red-500",
    ),
})
